import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../services/api';

export default function PartnerRegister() {
  const [formData, setFormData] = useState({
    company_name: '',
    company_type: '',
    primary_contact_name: '',
    primary_contact_email: '',
    primary_contact_phone: '',
    password: '',
    business_use_case: '',
    expected_volume: '',
    geographic_interest: '',
  });
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: '' });
  };

  const validate = () => {
    const errors = {};
    if (formData.password.length < 12) errors.password = 'Password must be at least 12 characters';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.primary_contact_email)) errors.primary_contact_email = 'Invalid email format';
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!validate()) return;
    setLoading(true);

    try {
      const data = {
        ...formData,
        expected_volume: formData.expected_volume ? parseInt(formData.expected_volume) : null,
      };
      const result = await api.partnerRegister(data);
      setApiKey(result.api_key);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (apiKey) {
    return (
      <div className="auth-container">
        <div className="auth-box" style={{ maxWidth: '500px' }}>
          <h2>Registration Successful</h2>
          <p>Your API key (save it now — it won't be shown again):</p>
          <div style={{ background: '#f4f4f4', padding: '12px', borderRadius: '4px', fontFamily: 'monospace', wordBreak: 'break-all', margin: '16px 0' }}>
            {apiKey}
          </div>
          <p>Your account is pending approval.</p>
          <button onClick={() => navigate('/partner/login')}>Go to Login</button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box" style={{ maxWidth: '600px' }}>
        <h2>Partner Registration</h2>
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Company Name *</label>
            <input name="company_name" value={formData.company_name} onChange={handleChange} required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Company Type</label>
              <select name="company_type" value={formData.company_type} onChange={handleChange}>
                <option value="">Select...</option>
                <option value="aggregator">Aggregator</option>
                <option value="marketplace">Marketplace</option>
                <option value="lead_provider">Lead Provider</option>
                <option value="analytics">Analytics</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label>Expected Monthly Volume</label>
              <input type="number" name="expected_volume" value={formData.expected_volume} onChange={handleChange} placeholder="e.g., 10000" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Contact Name *</label>
              <input name="primary_contact_name" value={formData.primary_contact_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Contact Email *</label>
              <input type="email" name="primary_contact_email" value={formData.primary_contact_email} onChange={handleChange} required />
              {fieldErrors.primary_contact_email && <span className="field-error">{fieldErrors.primary_contact_email}</span>}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Contact Phone *</label>
              <input name="primary_contact_phone" value={formData.primary_contact_phone} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Password * (min 12 characters)</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} required minLength={12} />
              {fieldErrors.password && <span className="field-error">{fieldErrors.password}</span>}
            </div>
          </div>
          <div className="form-group">
            <label>Business Use Case</label>
            <textarea name="business_use_case" value={formData.business_use_case} onChange={handleChange} placeholder="Describe how you plan to use the inventory data..." />
          </div>
          <div className="form-group">
            <label>Geographic Interest</label>
            <input name="geographic_interest" value={formData.geographic_interest} onChange={handleChange} placeholder="e.g., Texas, Southwest US" />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>
        <div className="link">
          <Link to="/partner/login">Already have an account? Login</Link>
        </div>
      </div>
    </div>
  );
}
